var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#3B82F6",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.538 12.02c1.4-.1 3.116.129 2.736 2.59-.465 2.96-2.58 2.596-3.51 2.615.344-2.162.534-3.553.774-5.205Zm8.06 11.903c.365.79 0 1.79-.759 2.192-.434.228-.926.444-1.422.562a12.19 12.19 0 0 1-2.492.32c-1.345 0-2.685-.753-3.267-1.669-.147.316-.693.95-1.639 1.254-.597.19-1.322.418-2.825.418-1.353-.004-2.124-.604-2.527-1.106-.65-.805-.744-1.82-.62-2.503l.008-.034c.507-2.508 1.201-7.063 1.527-9.347v-.022c.089-.639.178-1.27.232-1.908.027-.323.043-.645.047-.968 0-.304-.027-.608-.027-.912.003-.289.054-.578.19-.836.224-.41.631-.73 1.065-.874.473-.156.97-.22 1.461-.273.504-.054 1.008-.107 1.512-.149.62-.045 1.236-.068 1.856-.068 1.058 0 2.12.019 3.162.228 1.062.217 2.136.623 2.976 1.341a5.777 5.777 0 0 1 1.372 1.797c.299.597.423 1.231.496 1.71a7.085 7.085 0 0 1-.1 2.602 5.77 5.77 0 0 1-.772 1.752 7.242 7.242 0 0 1-1.561 1.687c.403 1.136 1.441 3.347 2.108 4.806ZM13.718 10.318c.027.417.027.84.008 1.26-.016.43-.054.86-.105 1.293-.046.425-.104.847-.166 1.272l-.016.137c-.186 1.33-.384 2.656-.585 3.974-.221 1.394-.461 2.774-.702 4.16-.108.65-.364 1.474-.019 2.09.306.55 1.093.62 1.64.562 1.995-.201 2.317-.638 2.317-.638-.4-.433-.055-2.405.345-5.053h1.422l1.484 4.403s.438 1.364 1.659 1.3c1.558-.088 2.7-.434 2.871-.627-.476-.262-1.852-3.632-2.604-6.102.365-.22.717-.452 1.047-.718.453-.36.872-.779 1.193-1.265.233-.353.411-.74.512-1.151a4.8 4.8 0 0 0 .1-.669 4.957 4.957 0 0 0-.034-1.174c-.059-.376-.14-.79-.31-1.128-.314-.627-.764-1.178-1.372-1.531-1.031-.593-2.217-.707-3.372-.772a21.788 21.788 0 0 0-3.759.122c-.147.019-1.562.144-1.554.255Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon01);
export default __webpack_public_path__ + "static/media/company-icon-01.04c09e4766b6cdb0880f886f58136643.svg";
export { ForwardRef as ReactComponent };